<div class="header-container">
  <div class="logo-container">
    <!-- <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a> -->
    <!-- <a class="logo" href="#" (click)="navigateHome()">{{headername}}-<span style="color: red;" nbTooltip={{regionnametip}} nbTooltipStatus="primary">{{headerClientName}}</span></a> -->
    <a class="logo" href="#" (click)="navigateHome()">{{headername}} <span style="color: red;">{{headerClientName}}</span></a>
  </div>
</div>

<div class="header-container">
  <div *ngIf="logoenable">
    <img class="logore" src={{imagepath}}>
    <img class="logore" src={{imagepath2}}>
  </div>
  <nb-actions size="small">
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-user  [name]="showname?.name"
        [picture]="pic?.picture">
      </nb-user>
      <nb-icon [nbContextMenu]="userMenu" nbContextMenuTag="userMenuTag" icon="more-vertical-outline"></nb-icon>
    </nb-action>
  </nb-actions>
</div>